import type { ButtonSchemaType, ButtonFontSchemaType } from '@vedalib/editor/lib/brand'
import styled from 'styled-components'

import { outline } from 'components/Editor/styled/Outline'
import { border, font, hover, shell } from 'services/Branding/common.styled'
import type { ElementFontCss, ElementStyleCss } from 'services/Branding/types'

const BaseButtonElementStyled = styled.button<{
  $styles: ElementStyleCss<ButtonSchemaType>
  $fonts: ElementFontCss<ButtonFontSchemaType>
}>`
  transition: 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  white-space: nowrap;
  cursor: pointer;
  position: relative;
  ${outline}

  height: 40px;
  background-color: ${({ $styles }) => $styles.button.backgroundColor};
  box-shadow: ${({ $styles }) => $styles.effects.boxShadow};

  ${({ $styles }) => hover({ $styles })}

  ${({ $styles }) => border($styles.border)}
  ${({ $styles }) => shell($styles.root)}
  ${({ $fonts }) => font($fonts.active)}
  font-size: 14px;
`

export default BaseButtonElementStyled
